import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';

import { RUN_MODE_TOKEN, RunMode } from 'src/environments/runtime';

import { REMOTE_PICKUP_PATH } from '../remote-pickup/routes';
import { VIEW_TYPES } from '../shared/utils/constants';

@Injectable()
export class CloudDeploymentGuardService implements CanActivate {
  private readonly activationUrl = `/${VIEW_TYPES.SETUP}`;

  constructor(private router: Router, @Inject(RUN_MODE_TOKEN) private runMode: RunMode) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    if (this.runMode === 'device') {
      return of(true);
    }

    if (this.runMode === 'remote-pickup') {
      if (state.url.startsWith(REMOTE_PICKUP_PATH)) {
        return of(true);
      }
      this.router.navigate([REMOTE_PICKUP_PATH]);
      return of(false);
    }

    if (state.url.startsWith(REMOTE_PICKUP_PATH)) {
      this.router.navigate([this.activationUrl]);
      return of(false);
    }

    return of(true);
  }
}
